export default __webpack_public_path__ + "static/media/logo.52775d06.png";